<template>
	<main class="main">
		<div class="title">
			<img src="@/assets/cttq.svg" alt="logo">
			<span class="title-text">网页导航</span>
		</div>
		<div class="search-box">
			<el-input
				v-model="searchText" v-sensor-count="'102240'"
				style="width: 55%; max-width: 650px;height: 42px;"
				placeholder="搜索"
				@keyup.enter="searchOnBaidu">
				<template #prefix>
					<el-icon class="el-input__icon">
						<search />
					</el-icon>
				</template>
			</el-input>
			<el-button
				v-sensor-count="'102241'" class="search-btn"
				type="primary"
				@click="searchOnAI">
				AI搜索
			</el-button>
			<el-button v-sensor-count="'102241'" class="search-btn" @click="searchOnBaidu">
				百度搜索
			</el-button>
		</div>
		<div class="show-card">
			<setting-card
				v-for="item in navigationGroups"
				:key="item.key"
				:line="item.line"
				:group-title="item.groupName"
				:group-items="item.groupItems" />
		</div>
		<div class="bottom">
			Copyright©正大天晴药业集团股份有限公司.All Rights Reserved.
			<a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备05004426号</a>
		</div>
		<div id="float-card" class="float-card">
			<div class="float-card-close" @click="close()">
				<img src="@/assets/close.png" alt="">
			</div>
			<a
				v-sensor-count="'102313'" class="float-card-img"
				href="https://ainew2prd.cttq.com/cvue/ITService-WebPC/robotChat"
				target="_blank">
				<img src="@/assets/cttq_center_float.png" alt="">
			</a>
		</div>
	</main>
</template>

<script setup lang="ts">
import SettingCard from "./SettingCard.vue";
import { navigationGroups } from "./navigationGroups";
import { ref } from "vue";
import { Search } from "@element-plus/icons-vue";
const searchText = ref("");
function searchOnAI() {
	if (searchText.value) {
		window.open(`${import.meta.env.VITE_BASE_URL}&question=${encodeURIComponent(searchText.value)}`);
	}
}
function searchOnBaidu() {
	if (searchText.value) {
		window.open(`https://www.baidu.com/s?wd=${encodeURIComponent(searchText.value)}`);
	}
}
function close(){
	let dom = document.getElementById("float-card");
	if(dom){
		dom.style.display = "none";
	}
}
</script>

<style>
.main{
	height: 100%;
	display: flex;
	flex-direction: column;
}
.title{
	text-align: center;
	margin: 31px 0 15px;
	/* margin-bottom: 20px; */
}
.title-text{
	margin-left: 7px;
	font-family: PingFangSC-Regular;
	font-size: 14px;
	color: #646464;
}
.search-box{
	width: 100%;
	text-align: center;
	margin-bottom: 20px;
}
.search-btn{
	margin-left: 10px;
	width: 80px;
	height: 42px;
}
.el-button>span{
	font-weight: 600;
}
.show-card {
	/* width: 80vw; */
	max-width: 1180px;
	border-radius: 8px;
	padding: 22px 0 22px 0;
	background-color: #fff;
	/* height: 540px; */
	/* min-width: 540px; */
	overflow: hidden;
	margin-bottom: 16px;
}

.bottom{
	font-family: PingFangSC-Regular;
	font-size: 14px;
	color: #323232;
	flex: 1;
	text-align: center;
	vertical-align: bottom;
}

.bottom>a{
	font-size: 14px;
	color: #08519A;
}
.float-card{
	position: fixed;
	right: 16px;
	bottom: 0;
}
.float-card-close{
	float: right;
	cursor: pointer;
}
.float-card-img>img{
	width: 168px;
	height: 450px;
}
</style>
